import * as Yup from 'yup';
import { ChatAssistant } from '../../../../../shared/types/chat-assistant';

export const initialValues: ChatAssistant = {
    name: '',
    description: '',
    project: '',
    apiKeyIa: '',
    isAdvancedMode: false,
    displayName: '',
    authorizedManagers: [],
};

export const validationSchema = (
    isApiKeyFounded: boolean,
    isSearched: boolean
) =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        description: Yup.string().required('La descripción es obligatoria'),
        project: Yup.string().required('El proyecto es obligatorio'),
        apiKeyIa:
            isSearched && !isApiKeyFounded
                ? Yup.string().required('La API KEY IA es obligatoria')
                : Yup.string(),
        displayName: Yup.string().required(
            'El nombre a mostrar es obligatorio'
        ),
    });
